export const payload = {
  receiveMutation: 'RECEIVE_FREEFIELDS',
  receivingMutation: 'RECEIVING_FREEFIELDS',
  receiveMetadataMutation: 'RECEIVE_FREEFIELD_METADATA',
  receiveFailureMutation: 'RECEIVE_FREEFIELD_FAILURE',
  savingMutation: 'SAVING_FREEFIELD',
  saveFailureMutation: 'SAVING_FREEFIELD_FAILURE',
  incrementMutation: 'INCREMENT_FREEFIELD_COUNT',
  updatingMutation: 'UPDATING_FREEFIELD',
  updateFailureMutation: 'UPDATING_FREEFIELD_FAILURE',
  deleteMutation: 'DELETE_FREEFIELD',
  deletingMutation: 'DELETING_FREEFIELD',
  deleteFailureMutation: 'DELETING_FREEFIELD_FAILURE',
  resetMetaMutation: 'RESET_FREEFIELD_META',
  clearMutation: 'CLEAR_FREEFIELD_STATE',
  moduleName: 'freefield',
  endpoint: 'freefields',
  searchableFields: ['code', 'name', 'description']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Freefields/actionPayload.js